export interface RecommendedActions {
  lead: string | null;
  items: string[];
}

// Rule messages arrive as one flattened line: authored breaks survive only as runs of 2+ spaces.
const unflatten = (text: string) => text.replace(/[ \t]{2,}/g, '\n');

// Rule messages are free text; "…causes are: 1. … 2. … 3. …" is the one shape worth lifting into a list.
export function formatActions(text: string | null | undefined): RecommendedActions {
  const source = (text ?? '').trim();

  const lines = source.split(/\r?\n/).map(line => line.trim()).filter(Boolean);
  const firstNumbered = lines.findIndex(line => /^\d{1,2}[.)]\s/.test(line));
  if (lines.length > 1 && firstNumbered >= 0) {
    const items: string[] = [];
    for (const line of lines.slice(firstNumbered)) {
      const marker = /^\d{1,2}[.)]\s*/.exec(line);
      if (marker) items.push(line.slice(marker[0].length));
      else if (items.length) items[items.length - 1] += ' ' + line;
    }
    return { lead: lines.slice(0, firstNumbered).join('\n') || null, items: items.filter(Boolean) };
  }

  const listStart = /:\s*(?=1\.\s)/.exec(source);
  if (!listStart) return { lead: unflatten(source) || null, items: [] };

  const lead = unflatten(source.slice(0, listStart.index + 1).trim());
  const rest = source.slice(listStart.index + listStart[0].length);
  const starts = [0];
  const marker = /\s(\d{1,2})\.\s/g;
  for (let hit = marker.exec(rest); hit; hit = marker.exec(rest)) {
    if (Number(hit[1]) === starts.length + 1) starts.push(hit.index);
  }
  const items = starts.map((s, i) => rest.slice(s, starts[i + 1]).replace(/^\s*\d+\.\s*/, '').trim()).filter(Boolean);
  return { lead: lead || null, items };
}
